/* import { useState, useEffect } from "react";
import { uiAlert } from "../alerts/customAlert/uiAlert";
import { useSelector } from "react-redux";
import PaymentMode from "../../screens/stores/makeTansaction/operationTypeCustomerDetails/checkOutPaymentAccount/PaymentMode";
const PAYMENT_MODES = ["cash", "POS", "mobilePay"];

export default function RegisterPaymentModal({
  isOpen,
  balance = 25229,
  onCancel,
  onConfirm,
  splitPaymentAmount,
  setSplitPaymentAmount,
  loanPaymentMode,
  setLoanPaymentMode,
  currency = "NGN",
}) {
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);
  const { store } = useSelector((state) => state.store);
  const [payment, setPayment] = useState(null);

  useEffect(() => {
    if (payment) {
      setLoanPaymentMode(payment.isSplit ? "split" : payment.paymentType);
    }
  }, [payment]);

  if (!isOpen) return null;

  const val = parseFloat(splitPaymentAmount) || 0;
  const isOverBalance = val > balance;
  const isValid = val > 0 && !isOverBalance;
  const pct = Math.min((val / balance) * 100, 100);

  const fmt = (n) => new Intl.NumberFormat("en-NG", { style: "currency", currency: "NGN", minimumFractionDigits: 0 }).format(n);

  const handleConfirm = async () => {
  
    const payments_ = payment.isSplit
      ? payment.splits.map((split) => ({
          paymentType: split.paymentType,
          amount: split.amount,
          account: split.accountId,
          receivingAccountName: split.accountName,
          reference: split.reference,
          paidAt: new Date(),
          isPartner: split.isPartner,
        }))
      : [
          {
            paymentType: payment.paymentType,
            amount: payment.amountPaid,
            account: payment.accountId,
            receivingAccountName: payment.accountName,
            reference: payment.reference,
            paidAt: new Date(),
            isPartner: payment.isPartner,
          },
        ];

    const paymentMode_ = payment.isSplit ? "split" : payment.paymentType;
    console.log(payment, payments_, "payment and payments_");

    if (!isValid) return;
    setLoading(true);

    const result = await onConfirm?.({ splitPaymentAmount: val, loanPaymentMode: paymentMode_, payment: payments_ });

    setLoading(false);
    if (result === false) return;

    setDone(true);
  };

  const hint = isOverBalance
    ? `Exceeds balance of ${currency} ${balance.toLocaleString()}`
    : val > 0
      ? `${currency} ${(balance - val).toLocaleString()} remaining`
      : "";

  return (
    <div onClick={onCancel} style={s.overlay}>
      <div
        onClick={(e) => {
          e.stopPropagation();
        }}
        style={s.modal}
      >
        {!done ? (
          <>
           
            <div style={s.header}>
              <div style={s.iconWrap}>
                <svg width='20' height='20' viewBox='0 0 24 24' fill='none' stroke='#4A90E2' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'>
                  <rect x='2' y='5' width='20' height='14' rx='2' />
                  <line x1='2' y1='10' x2='22' y2='10' />
                </svg>
              </div>
              <p style={s.title}>How much did the customer pay?</p>
              <div style={s.balanceRow}>
                <span style={s.balanceLabel}>Customer balance:</span>
                <span style={s.balanceVal}>
                  {currency} {balance.toLocaleString()}
                </span>
              </div>
            </div>

         
            <div style={s.body}>
             
              <div style={s.field}>
                <label style={s.label}>Amount paid</label>
                <div style={s.inputWrap}>
                  <span style={s.currency}>{currency}</span>
                  <input
                    type='number'
                    value={splitPaymentAmount}
                    placeholder='0'
                    min='0'
                    onChange={(e) => setSplitPaymentAmount(Number(e.target.value))}
                    style={{
                      ...s.input,
                      borderColor: isOverBalance ? "#fca5a5" : splitPaymentAmount && isValid ? "#bfdbfe" : "#e5e7eb",
                      background: isOverBalance ? "#fff5f5" : "#f9fafb",
                    }}
                    onFocus={(e) => {
                      if (!isOverBalance) e.target.style.borderColor = "#bfdbfe";
                      e.target.style.background = "#ffffff";
                    }}
                    onBlur={(e) => {
                      if (!isOverBalance) e.target.style.borderColor = "#e5e7eb";
                      if (!isOverBalance) e.target.style.background = "#f9fafb";
                    }}
                  />
                </div>
                <span style={{ ...s.hint, color: isOverBalance ? "#ef4444" : "#6b7280" }}>{hint}</span>
                <div style={s.progressWrap}>
                  <div
                    style={{
                      ...s.progressBar,
                      width: `${pct}%`,
                      background: isOverBalance ? "#ef4444" : pct >= 90 ? "#f59e0b" : "#4A90E2",
                    }}
                  />
                </div>
              </div>

              
             

              <PaymentMode totalDue={splitPaymentAmount} paymentAccounts={store?.storeReceivingAccounts || []} onChange={setPayment} />
            </div>

           
            <div style={s.footer}>
              <button
                onClick={onCancel}
                disabled={loading}
                style={s.cancelBtn}
                onMouseOver={(e) => (e.currentTarget.style.background = "#f9fafb")}
                onMouseOut={(e) => (e.currentTarget.style.background = "#ffffff")}
              >
                Cancel
              </button>
              <button
                onClick={handleConfirm}
                disabled={!isValid || loading}
                style={{ ...s.confirmBtn, background: !isValid || loading ? "#93c5fd" : "#4A90E2", cursor: !isValid || loading ? "not-allowed" : "pointer" }}
                onMouseOver={(e) => {
                  if (isValid && !loading) e.currentTarget.style.background = "#3a7bc8";
                }}
                onMouseOut={(e) => {
                  if (isValid && !loading) e.currentTarget.style.background = "#4A90E2";
                }}
              >
                {loading ? (
                  <span style={s.spinnerWrap}>
                    <span style={s.spinner} />
                    Registering…
                  </span>
                ) : (
                  "Register payment"
                )}
              </button>
            </div>
          </>
        ) : (
          <div style={s.success}>
            <div style={s.successIcon}>
              <svg width='28' height='28' viewBox='0 0 24 24' fill='none' stroke='#15803d' strokeWidth='2.5' strokeLinecap='round' strokeLinejoin='round'>
                <polyline points='20 6 9 17 4 12' />
              </svg>
            </div>
            <p style={s.successTitle}>Payment registered</p>
            <p style={s.successSub}>
              {currency} {val?.toLocaleString()} received via {loanPaymentMode}
            </p>
          </div>
        )}
      </div>
      <style>{`@keyframes rpm-spin { to { transform: rotate(360deg); } }`}</style>
    </div>
  );
}

const s = {
  overlay: {
    position: "fixed",
    inset: 0,
    background: "rgba(0,0,0,0.45)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 1000,
    padding: "16px",
  },
  modal: {
    background: "#ffffff",
    borderRadius: "16px",
    width: "100%",
    maxWidth: "420px",
    boxShadow: "0 20px 60px rgba(0,0,0,0.15)",
    overflow: "hidden",
  },
  header: {
    padding: "28px 28px 0",
    background: "#ffffff",
  },
  iconWrap: {
    width: "44px",
    height: "44px",
    borderRadius: "50%",
    background: "#eff6ff",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginBottom: "14px",
  },
  title: {
    fontSize: "17px",
    fontWeight: 600,
    color: "#111827",
    margin: "0 0 4px",
  },
  balanceRow: {
    display: "flex",
    alignItems: "center",
    gap: "6px",
  },
  balanceLabel: {
    fontSize: "13px",
    color: "#6b7280",
  },
  balanceVal: {
    fontSize: "13px",
    fontWeight: 600,
    color: "#4A90E2",
  },
  body: {
    padding: "20px 28px",
    display: "flex",
    flexDirection: "column",
    gap: "16px",
    background: "#ffffff",
  },
  field: {
    display: "flex",
    flexDirection: "column",
    gap: "6px",
  },
  label: {
    fontSize: "13px",
    color: "#6b7280",
    fontWeight: 500,
  },
  inputWrap: {
    position: "relative",
  },
  currency: {
    position: "absolute",
    left: "12px",
    top: "50%",
    transform: "translateY(-50%)",
    fontSize: "14px",
    fontWeight: 600,
    color: "#9ca3af",
    pointerEvents: "none",
    zIndex: 1,
  },
  input: {
    width: "100%",
    padding: "11px 12px 11px 32px",
    fontSize: "18px",
    fontWeight: 600,
    color: "#111827",
    background: "#f9fafb",
    border: "1px solid #e5e7eb",
    borderRadius: "10px",
    outline: "none",
    boxShadow: "none",
    transition: "border-color 0.15s, background 0.15s",
  },
  hint: {
    fontSize: "12px",
    minHeight: "16px",
  },
  progressWrap: {
    background: "#f3f4f6",
    borderRadius: "99px",
    height: "5px",
    overflow: "hidden",
  },
  progressBar: {
    height: "100%",
    borderRadius: "99px",
    transition: "width 0.3s ease, background 0.3s",
  },
  select: {
    width: "100%",
    padding: "10px 12px",
    fontSize: "14px",
    color: "#111827",
    background: "#f9fafb",
    border: "1px solid #e5e7eb",
    borderRadius: "10px",
    outline: "none",
    boxShadow: "none",
    cursor: "pointer",
    transition: "border-color 0.15s",
  },
  footer: {
    borderTop: "1px solid #f3f4f6",
    padding: "16px 28px",
    display: "flex",
    gap: "10px",
    background: "#ffffff",
  },
  cancelBtn: {
    flex: 1,
    minWidth: "90px",
    padding: "10px",
    fontSize: "14px",
    fontWeight: 500,
    cursor: "pointer",
    borderRadius: "8px",
    background: "#ffffff",
    border: "1px solid #d1d5db",
    color: "#374151",
    transition: "background 0.15s",
  },
  confirmBtn: {
    flex: 1,
    minWidth: "90px",
    padding: "10px",
    fontSize: "14px",
    fontWeight: 600,
    borderRadius: "8px",
    border: "none",
    color: "#ffffff",
    transition: "background 0.15s",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "8px",
  },
  spinnerWrap: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
  },
  spinner: {
    width: "14px",
    height: "14px",
    border: "2px solid rgba(255,255,255,0.35)",
    borderTopColor: "#ffffff",
    borderRadius: "50%",
    animation: "rpm-spin 0.6s linear infinite",
    display: "inline-block",
    flexShrink: 0,
  },
  success: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    padding: "40px 28px",
    textAlign: "center",
    background: "#ffffff",
  },
  successIcon: {
    width: "56px",
    height: "56px",
    borderRadius: "50%",
    background: "#f0fdf4",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginBottom: "16px",
  },
  successTitle: {
    fontSize: "17px",
    fontWeight: 600,
    color: "#111827",
    marginBottom: "6px",
  },
  successSub: {
    fontSize: "14px",
    color: "#6b7280",
    margin: 0,
  },
}; */

import { useState, useEffect, useRef } from "react";
import { uiAlert } from "../alerts/customAlert/uiAlert";
import { useSelector } from "react-redux";
import PaymentMode from "../../screens/stores/makeTansaction/operationTypeCustomerDetails/checkOutPaymentAccount/PaymentMode";
const PAYMENT_MODES = ["cash", "POS", "mobilePay"];

export default function RegisterPaymentModal({
  isOpen,
  balance = 25229,
  onCancel,
  onConfirm,
  splitPaymentAmount,
  setSplitPaymentAmount,
  loanPaymentMode,
  setLoanPaymentMode,
  currency = "NGN",
  pushToTerminal, // async ({ accountId, accountName, provider, amount, sellToken, postype, reference, serialNumber }) => { success: boolean, message?: string }
  socket, // same socket instance CashPaymentOverlay uses — listens for "kudaPaymentSuccessful"
  transID, // the transaction this payment belongs to, for socket.emit("joinPaymentRoom", transID)
}) {
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);
  const { store } = useSelector((state) => state.store);
  const [payment, setPayment] = useState(null);
  const advanceQueueRef = useRef(null);
  const rollingID = Math.random().toString(36).slice(2, 14);

  // Terminal-push flow — mirrors CashPaymentOverlay's pattern. pushState
  // drives the animated overlay (pushing/waiting/success/fail); pushQueue
  // holds any remaining partner accounts still to push (a split payment
  // can touch more than one partner terminal).
  const [pushState, setPushState] = useState(null);
  const [pushQueue, setPushQueue] = useState([]);

  useEffect(() => {
    console.log(payment, "payment");

    if (payment) {
      setLoanPaymentMode(payment.isSplit ? "split" : payment.paymentType);
    }
  }, [payment]);

  // Listens for the partner terminal's webhook confirmation coming back
  // over the socket while pushState is "waiting". On success, shows the
  // success animation briefly, then advances to the next queued partner
  // (if a split touched more than one), or finalizes the registration.
  useEffect(() => {
    if (!socket) return;

    const handleKudaPaymentSuccessful = async (data) => {
      setPushState((prev) => (prev ? { ...prev, status: "success", message: data?.message || "Payment successful" } : prev));
      await new Promise((resolve) => setTimeout(resolve, 1800));
      setPushState(null);
      advanceQueueRef.current?.();
    };

    socket.on("kudaPaymentSuccessful", handleKudaPaymentSuccessful);
    return () => {
      socket.off("kudaPaymentSuccessful", handleKudaPaymentSuccessful);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [socket]);

  if (!isOpen) return null;

  const val = parseFloat(splitPaymentAmount) || 0;
  const isOverBalance = val > balance;
  const isValid = val > 0 && !isOverBalance;
  const pct = Math.min((val / balance) * 100, 100);

  const fmt = (n) => new Intl.NumberFormat("en-NG", { style: "currency", currency: "NGN", minimumFractionDigits: 0 }).format(n);

  const buildPaymentsPayload = () => {
    const payments_ = payment.isSplit
      ? payment.splits.map((split) => ({
          paymentType: split.paymentType,
          amount: split.amount,
          account: split.accountId,
          receivingAccountName: split.accountName,
          reference: split.reference,
          paidAt: new Date(),
          isPartner: split.isPartner,
        }))
      : [
          {
            paymentType: payment.paymentType,
            amount: payment.amountPaid,
            account: payment.accountId,
            receivingAccountName: payment.accountName,
            reference: payment.reference,
            paidAt: new Date(),
            isPartner: payment.isPartner,
          },
        ];
    const paymentMode_ = payment.isSplit ? "split" : payment.paymentType;
    return { payments_, paymentMode_ };
  };

  // Normalizes a single-payment payload or one split row into the shape
  // handlePushToTerminal expects — single payments carry `amountPaid`,
  // split rows carry `amount`.
  const toPushEntry = (p) => ({
    accountId: p.accountId,
    accountName: p.accountName,
    provider: p.provider,
    amount: payment.isSplit ? p.amount : p.amountPaid,
    isPartner: p.isPartner,
    reference: p.reference,
    serialNumber: p.serialNumber,
  });

  // Every account in this payment that's wired to a partner integration —
  // a single payment has at most one, a split can have several.
  const getPartnerEntries = () => {
    if (!payment) return [];
    const source = payment.isSplit ? payment.splits : [payment];
    return source.filter((p) => p.isPartner?.hasIntgration).map(toPushEntry);
  };

  const finalizeRegisterPayment = async () => {
    const { payments_, paymentMode_ } = buildPaymentsPayload();
    setLoading(true);
    const result = await onConfirm?.({ splitPaymentAmount: val, loanPaymentMode: paymentMode_, payment: payments_ });
    setLoading(false);
    if (result === false) return;
    setDone(true);
    onCancel();
  };

  // Pops the next queued partner account and pushes it; once the queue is
  // empty, the payment is actually registered.
  const advanceQueue = () => {
    setPushQueue((prev) => {
      if (prev.length > 0) {
        const [next, ...rest] = prev;
        handlePushToTerminal(next);
        return rest;
      }
      finalizeRegisterPayment();
      return prev;
    });
  };

  advanceQueueRef.current = advanceQueue;

  const handlePushToTerminal = async (entry) => {
    setPushState({ entry, status: "pushing" });
    socket?.emit("joinPaymentRoom", rollingID);

    try {
      const result = await pushToTerminal({
        accountId: entry.accountId,
        accountName: entry.accountName,
        provider: entry.provider,
        amount: entry.amount,
        sellToken: entry.isPartner?.sellToken,
        postype: entry.isPartner?.postype,
        reference: entry.reference,
        serialNumber: entry.serialNumber,
        transID: rollingID,
      });

      const success = result?.success === true;
      if (success) {
        setPushState({ entry, status: "waiting", message: result?.message });
      } else {
        setPushState({ entry, status: "fail", message: result?.message || "Something unexpected happened" });
      }
    } catch (err) {
      setPushState({ entry, status: "fail", message: err?.message || "Couldn't reach the terminal" });
    }
  };

  const handleRegisterClick = async () => {
    if (!isValid || !payment) return;

    const partnerEntries = getPartnerEntries();

    if (partnerEntries.length === 0 || typeof pushToTerminal !== "function") {
      if (partnerEntries.length > 0) {
        console.warn("RegisterPaymentModal: partner account selected but no pushToTerminal prop was passed — registering directly.");
      }
      await finalizeRegisterPayment();
      return;
    }

    // Push the first partner account now; any remaining ones are pushed
    // one at a time as each prior one is confirmed (see advanceQueue).
    setPushQueue(partnerEntries.slice(1));
    handlePushToTerminal(partnerEntries[0]);
  };

  const isPushingPayment = pushState !== null || pushQueue.length > 0;

  const hint = isOverBalance
    ? `Exceeds balance of ${currency} ${balance.toLocaleString()}`
    : val > 0
      ? `${currency} ${(balance - val).toLocaleString()} remaining`
      : "";

  return (
    <div onClick={onCancel} style={s.overlay}>
      <div
        onClick={(e) => {
          e.stopPropagation();
        }}
        style={s.modal}
      >
        {!done ? (
          <>
            {/* Header */}
            <div style={s.header}>
              <div style={s.iconWrap}>
                <svg width='20' height='20' viewBox='0 0 24 24' fill='none' stroke='#4A90E2' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'>
                  <rect x='2' y='5' width='20' height='14' rx='2' />
                  <line x1='2' y1='10' x2='22' y2='10' />
                </svg>
              </div>
              <p style={s.title}>How much did the customer pay?</p>
              <div style={s.balanceRow}>
                <span style={s.balanceLabel}>Customer balance:</span>
                <span style={s.balanceVal}>
                  {currency} {balance.toLocaleString()}
                </span>
              </div>
            </div>

            {/* Body */}
            <div style={s.body}>
              {/* Amount */}
              <div style={s.field}>
                <label style={s.label}>Amount paid</label>
                <div style={s.inputWrap}>
                  <span style={s.currency}>{currency}</span>
                  <input
                    type='number'
                    value={splitPaymentAmount}
                    placeholder='0'
                    min='0'
                    onChange={(e) => setSplitPaymentAmount(Number(e.target.value))}
                    style={{
                      ...s.input,
                      borderColor: isOverBalance ? "#fca5a5" : splitPaymentAmount && isValid ? "#bfdbfe" : "#e5e7eb",
                      background: isOverBalance ? "#fff5f5" : "#f9fafb",
                    }}
                    onFocus={(e) => {
                      if (!isOverBalance) e.target.style.borderColor = "#bfdbfe";
                      e.target.style.background = "#ffffff";
                    }}
                    onBlur={(e) => {
                      if (!isOverBalance) e.target.style.borderColor = "#e5e7eb";
                      if (!isOverBalance) e.target.style.background = "#f9fafb";
                    }}
                  />
                </div>
                <span style={{ ...s.hint, color: isOverBalance ? "#ef4444" : "#6b7280" }}>{hint}</span>
                <div style={s.progressWrap}>
                  <div
                    style={{
                      ...s.progressBar,
                      width: `${pct}%`,
                      background: isOverBalance ? "#ef4444" : pct >= 90 ? "#f59e0b" : "#4A90E2",
                    }}
                  />
                </div>
              </div>

              <PaymentMode totalDue={splitPaymentAmount} paymentAccounts={store?.storeReceivingAccounts || []} onChange={setPayment} />
            </div>

            {/* Footer */}
            <div style={s.footer}>
              <button
                onClick={onCancel}
                disabled={loading || isPushingPayment}
                style={s.cancelBtn}
                onMouseOver={(e) => (e.currentTarget.style.background = "#f9fafb")}
                onMouseOut={(e) => (e.currentTarget.style.background = "#ffffff")}
              >
                Cancel
              </button>
              <button
                onClick={handleRegisterClick}
                disabled={!isValid || loading || isPushingPayment}
                style={{
                  ...s.confirmBtn,
                  background: !isValid || loading || isPushingPayment ? "#93c5fd" : "#4A90E2",
                  cursor: !isValid || loading || isPushingPayment ? "not-allowed" : "pointer",
                }}
                onMouseOver={(e) => {
                  if (isValid && !loading && !isPushingPayment) e.currentTarget.style.background = "#3a7bc8";
                }}
                onMouseOut={(e) => {
                  if (isValid && !loading && !isPushingPayment) e.currentTarget.style.background = "#4A90E2";
                }}
              >
                {loading ? (
                  <span style={s.spinnerWrap}>
                    <span style={s.spinner} />
                    Registering…
                  </span>
                ) : (
                  "Register payment"
                )}
              </button>
            </div>
          </>
        ) : (
          <div style={s.success}>
            <div style={s.successIcon}>
              <svg width='28' height='28' viewBox='0 0 24 24' fill='none' stroke='#15803d' strokeWidth='2.5' strokeLinecap='round' strokeLinejoin='round'>
                <polyline points='20 6 9 17 4 12' />
              </svg>
            </div>
            <p style={s.successTitle}>Payment registered</p>
            <p style={s.successSub}>
              {currency} {val?.toLocaleString()} received via {loanPaymentMode}
            </p>
          </div>
        )}

        {/* ---------- Terminal push animation overlay ---------- */}
        {pushState && (
          <div style={s.pushOverlay}>
            <div style={s.pushIconWrap}>
              {(pushState.status === "pushing" || pushState.status === "waiting") && (
                <svg
                  width='40'
                  height='40'
                  viewBox='0 0 24 24'
                  fill='none'
                  stroke='#4A90E2'
                  strokeWidth='2.5'
                  strokeLinecap='round'
                  style={{ animation: "rpm-spin 0.9s linear infinite" }}
                >
                  <path d='M21 12a9 9 0 1 1-6.219-8.56' />
                </svg>
              )}
              {pushState.status === "success" && (
                <div style={{ ...s.pushIconCircle, background: "#dcfce7", animation: "rpm-pop 0.3s ease" }}>
                  <svg width='22' height='22' viewBox='0 0 24 24' fill='none' stroke='#16a34a' strokeWidth='3' strokeLinecap='round' strokeLinejoin='round'>
                    <polyline points='20 6 9 17 4 12' />
                  </svg>
                </div>
              )}
              {pushState.status === "fail" && (
                <div style={{ ...s.pushIconCircle, background: "#fee2e2", animation: "rpm-pop 0.3s ease" }}>
                  <svg width='22' height='22' viewBox='0 0 24 24' fill='none' stroke='#dc2626' strokeWidth='3' strokeLinecap='round' strokeLinejoin='round'>
                    <circle cx='12' cy='12' r='10' />
                    <line x1='15' y1='9' x2='9' y2='15' />
                    <line x1='9' y1='9' x2='15' y2='15' />
                  </svg>
                </div>
              )}
            </div>

            <p style={s.pushTitle}>
              {pushState.status === "pushing" && `Pushing to ${pushState.entry.provider || "terminal"}…`}
              {pushState.status === "waiting" && `Waiting to collect payment from ${pushState.entry.provider || "terminal"}…`}
              {pushState.status === "success" && "Payment received"}
              {pushState.status === "fail" && "Payment failed"}
            </p>
            <p style={s.pushSubtitle}>
              {pushState.status === "pushing" && `Waiting for confirmation from ${pushState.entry.accountName}`}
              {pushState.status === "waiting" && (pushState.message || `Waiting to collect payment via ${pushState.entry.accountName}`)}
              {pushState.status === "success" && `Confirmed via ${pushState.entry.accountName}`}
              {pushState.status === "fail" && (pushState.message || `${pushState.entry.accountName} didn't confirm the payment`)}
            </p>

            {pushState.status === "fail" && (
              <div style={s.pushActions}>
                <button
                  type='button'
                  style={s.pushBtnGhost}
                  onClick={() => {
                    setPushState(null);
                    setPushQueue([]);
                  }}
                >
                  Cancel
                </button>
                <button type='button' style={s.pushBtnPrimary} onClick={() => handlePushToTerminal(pushState.entry)}>
                  Try again
                </button>
              </div>
            )}
            {pushState.status === "waiting" && (
              <div style={s.pushActions}>
                <button
                  type='button'
                  style={s.pushBtnGhost}
                  onClick={() => {
                    setPushState(null);
                    advanceQueue();
                  }}
                >
                  I have collected this payment
                </button>
              </div>
            )}
            {pushState.status === "pushing" && (
              <div style={s.pushActions}>
                <button
                  type='button'
                  style={s.pushBtnGhost}
                  onClick={() => {
                    setPushState(null);
                    advanceQueue();
                  }}
                >
                  Collect manually
                </button>
              </div>
            )}
          </div>
        )}
      </div>
      <style>{`
        @keyframes rpm-spin { to { transform: rotate(360deg); } }
        @keyframes rpm-pop { 0% { transform: scale(0.6); opacity: 0; } 100% { transform: scale(1); opacity: 1; } }
      `}</style>
    </div>
  );
}

const s = {
  overlay: {
    position: "fixed",
    inset: 0,
    background: "rgba(0,0,0,0.45)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 1000,
    padding: "16px",
  },
  modal: {
    position: "relative",
    background: "#ffffff",
    borderRadius: "16px",
    width: "100%",
    maxWidth: "420px",
    boxShadow: "0 20px 60px rgba(0,0,0,0.15)",
    overflow: "hidden",
  },
  header: {
    padding: "28px 28px 0",
    background: "#ffffff",
  },
  iconWrap: {
    width: "44px",
    height: "44px",
    borderRadius: "50%",
    background: "#eff6ff",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginBottom: "14px",
  },
  title: {
    fontSize: "17px",
    fontWeight: 600,
    color: "#111827",
    margin: "0 0 4px",
  },
  balanceRow: {
    display: "flex",
    alignItems: "center",
    gap: "6px",
  },
  balanceLabel: {
    fontSize: "13px",
    color: "#6b7280",
  },
  balanceVal: {
    fontSize: "13px",
    fontWeight: 600,
    color: "#4A90E2",
  },
  body: {
    padding: "20px 28px",
    display: "flex",
    flexDirection: "column",
    gap: "16px",
    background: "#ffffff",
  },
  field: {
    display: "flex",
    flexDirection: "column",
    gap: "6px",
  },
  label: {
    fontSize: "13px",
    color: "#6b7280",
    fontWeight: 500,
  },
  inputWrap: {
    position: "relative",
  },
  currency: {
    position: "absolute",
    left: "12px",
    top: "50%",
    transform: "translateY(-50%)",
    fontSize: "14px",
    fontWeight: 600,
    color: "#9ca3af",
    pointerEvents: "none",
    zIndex: 1,
  },
  input: {
    width: "100%",
    padding: "11px 12px 11px 32px",
    fontSize: "18px",
    fontWeight: 600,
    color: "#111827",
    background: "#f9fafb",
    border: "1px solid #e5e7eb",
    borderRadius: "10px",
    outline: "none",
    boxShadow: "none",
    transition: "border-color 0.15s, background 0.15s",
  },
  hint: {
    fontSize: "12px",
    minHeight: "16px",
  },
  progressWrap: {
    background: "#f3f4f6",
    borderRadius: "99px",
    height: "5px",
    overflow: "hidden",
  },
  progressBar: {
    height: "100%",
    borderRadius: "99px",
    transition: "width 0.3s ease, background 0.3s",
  },
  select: {
    width: "100%",
    padding: "10px 12px",
    fontSize: "14px",
    color: "#111827",
    background: "#f9fafb",
    border: "1px solid #e5e7eb",
    borderRadius: "10px",
    outline: "none",
    boxShadow: "none",
    cursor: "pointer",
    transition: "border-color 0.15s",
  },
  footer: {
    borderTop: "1px solid #f3f4f6",
    padding: "16px 28px",
    display: "flex",
    gap: "10px",
    background: "#ffffff",
  },
  cancelBtn: {
    flex: 1,
    minWidth: "90px",
    padding: "10px",
    fontSize: "14px",
    fontWeight: 500,
    cursor: "pointer",
    borderRadius: "8px",
    background: "#ffffff",
    border: "1px solid #d1d5db",
    color: "#374151",
    transition: "background 0.15s",
  },
  confirmBtn: {
    flex: 1,
    minWidth: "90px",
    padding: "10px",
    fontSize: "14px",
    fontWeight: 600,
    borderRadius: "8px",
    border: "none",
    color: "#ffffff",
    transition: "background 0.15s",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "8px",
  },
  spinnerWrap: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
  },
  spinner: {
    width: "14px",
    height: "14px",
    border: "2px solid rgba(255,255,255,0.35)",
    borderTopColor: "#ffffff",
    borderRadius: "50%",
    animation: "rpm-spin 0.6s linear infinite",
    display: "inline-block",
    flexShrink: 0,
  },
  success: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    padding: "40px 28px",
    textAlign: "center",
    background: "#ffffff",
  },
  successIcon: {
    width: "56px",
    height: "56px",
    borderRadius: "50%",
    background: "#f0fdf4",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginBottom: "16px",
  },
  successTitle: {
    fontSize: "17px",
    fontWeight: 600,
    color: "#111827",
    marginBottom: "6px",
  },
  successSub: {
    fontSize: "14px",
    color: "#6b7280",
    margin: 0,
  },
  pushOverlay: {
    position: "absolute",
    inset: 0,
    zIndex: 5,
    background: "rgba(255,255,255,0.97)",
    backdropFilter: "blur(2px)",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    gap: "10px",
    padding: "32px 28px",
    textAlign: "center",
  },
  pushIconWrap: {
    marginBottom: "2px",
  },
  pushIconCircle: {
    width: "48px",
    height: "48px",
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  pushTitle: {
    fontSize: "16px",
    fontWeight: 600,
    color: "#111827",
    margin: 0,
  },
  pushSubtitle: {
    fontSize: "13px",
    color: "#6b7280",
    maxWidth: "280px",
    lineHeight: 1.5,
    margin: 0,
  },
  pushActions: {
    display: "flex",
    gap: "10px",
    marginTop: "10px",
  },
  pushBtnGhost: {
    padding: "10px 18px",
    borderRadius: "8px",
    border: "1px solid #d1d5db",
    background: "#ffffff",
    color: "#374151",
    fontSize: "13px",
    fontWeight: 600,
    cursor: "pointer",
  },
  pushBtnPrimary: {
    padding: "10px 18px",
    borderRadius: "8px",
    border: "none",
    background: "#4A90E2",
    color: "#ffffff",
    fontSize: "13px",
    fontWeight: 600,
    cursor: "pointer",
  },
};
